import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  updateDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { db } from "../firebase/firebaseConfig";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";


const containerStyle = {
  maxWidth: 1000,
  margin: "40px auto",
  padding: 30,
  background: "#f9fafb",
  borderRadius: 18,
};

const cardStyle = {
  background: "#ffffff",
  borderRadius: 14,
  padding: 20,
  marginBottom: 16,
  boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
};

const buttonStyle = {
  padding: "8px 14px",
  borderRadius: 8,
  border: "none",
  cursor: "pointer",
  fontWeight: 600,
};


const PurchaseOrders = () => {
  const [orders, setOrders] = useState([]);
  const storage = getStorage();
  const navigate = useNavigate();

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async () => {
    const snap = await getDocs(collection(db, "purchaseOrders"));
    setOrders(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  const downloadFile = async (path) => {
    if (!path) {
      alert("No file available for download.");
      return;
    }
  
    try {
      const url = await getDownloadURL(ref(storage, path));
      window.open(url, "_blank");
    } catch (err) {
      console.error("Download failed:", err);
      alert("Invoice file not found. It may not have been generated yet.");
    }
  };
  

  const approveOrder = async (order) => {
    await updateDoc(doc(db, "purchaseOrders", order.id), {
      status: "approved",
      approvedAt: serverTimestamp(),
      approvedBy: "admin",
    });
    loadOrders();
  };

  const downloadExcel = (order) => {
    const educator = order.educator || {};
    const school = order.school || {};
  
    const state = (school.state || "").toLowerCase();
    const grade = (educator.grade || "").toLowerCase();
    const view = "educator";
    const role = `${state}-${grade}-${view}`;
  
    const studentCount = Number(order.studentCount || 0);
  
    // Parse student names from notes (comma-separated)
    let studentNames = [];
    if (order.notes && typeof order.notes === "string") {
      studentNames = order.notes
        .split(",")
        .map(n => n.trim())
        .filter(Boolean);
    }
  
    // Build student columns
    const studentColumns = {};
    for (let i = 0; i < studentCount; i++) {
      const index = i + 1;
      const padded = String(index).padStart(2, "0");
  
      studentColumns[`Student${index} First Name`] =
        studentNames[i] || `Student${padded}`;
    }
  
    const row = {
      "Sir Name": educator.sirName || "",
      "First Name": educator.firstName || "",
      "Email": educator.email || "",
      "Password": "",
      "School Name": school.name || "",
      "School District": school.district || "",
      "State": school.state || "",
      "Grade": educator.grade || "",
      "View": "Educator",
      "Role": role,
      ...studentColumns,
    };
  
    const worksheet = XLSX.utils.json_to_sheet([row]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Educators");
  
    XLSX.writeFile(
      workbook,
      `EducatorImport_${order.poNumber || order.id}.xlsx`
    );
  };  

  return (
    <div style={containerStyle}>
      {/* LOGO HEADER */}
      <div style={{ textAlign: "center", marginBottom: 30 }}>
      <img
  src="https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2FSBLLogoBlackTM.png?alt=media&token=2f8fde38-b373-4367-9ade-a7b68bae3b6f"
  alt="BBL Logo"
  style={{ height: 80 }}
/>
        <h2 style={{ marginTop: 12 }}>Purchase Orders</h2>
        <p style={{ color: "#6b7280" }}>
          Review, approve, and manage submitted purchase orders
        </p>
      </div>
      <div>
     <button
  onClick={() => navigate("/admin-dashboard")}
  style={{
    marginTop: 10,
    padding: "8px 14px",
    borderRadius: 8,
    border: "none",
    background: "#e5e7eb",
    fontWeight: 600,
    cursor: "pointer",
  }}
>
  ← Return to Admin Dashboard
</button>
</div>
      {orders.map(order => (
        <div key={order.id} style={cardStyle}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <strong style={{ fontSize: 16 }}>
                {order.schoolName || "School"}
              </strong>
              <div style={{ fontSize: 13, color: "#6b7280" }}>
                PO #: {order.poNumber || "—"}
              </div>
            </div>

            <span
              style={{
                padding: "6px 12px",
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 700,
                background:
                  order.status === "pending"
                    ? "#FEF3C7"
                    : order.status === "approved"
                    ? "#DCFCE7"
                    : "#E5E7EB",
                color:
                  order.status === "pending"
                    ? "#92400E"
                    : order.status === "approved"
                    ? "#166534"
                    : "#374151",
              }}
            >
              {order.status?.toUpperCase()}
            </span>
          </div>

          <div style={{ marginTop: 14, fontSize: 14 }}>
            <div>
              <strong>
                {order.educator?.sirName} {order.educator?.firstName}{" "}
                {order.educator?.lastName}
              </strong>{" "}
              — Grade {order.educator?.grade}
            </div>
            <div style={{ color: "#6b7280" }}>
              {order.school?.district}, {order.school?.state}
            </div>
          </div>

          {/* ACTION BUTTONS */}
          <div
            style={{
              display: "flex",
              gap: 10,
              marginTop: 16,
              flexWrap: "wrap",
            }}
          >
            <button
              style={{ ...buttonStyle, background: "#e5e7eb" }}
              onClick={() => downloadExcel(order)}
            >
              Download Excel
            </button>

            <button
  style={{ ...buttonStyle, background: "#e5e7eb" }}
  onClick={() => downloadFile(order.poFilePath)}
>
  Download PO
</button>

{order.invoiceFilePath && (
  <button
    style={{ ...buttonStyle, background: "#d1fae5", color: "#065f46" }}
    onClick={() => downloadFile(order.invoiceFilePath)}
  >
    Download Invoice
  </button>
)}


            {order.status === "pending" && (
              <button
                style={{ ...buttonStyle, background: "#4f46e5", color: "#fff" }}
                onClick={() => approveOrder(order)}
              >
                Approve & Generate Invoice
              </button>
            )}
          </div>
        </div>
      ))}
       <button
  onClick={() => navigate("/admin-dashboard")}
  style={{
    marginTop: 10,
    padding: "8px 14px",
    borderRadius: 8,
    border: "none",
    background: "#e5e7eb",
    fontWeight: 600,
    cursor: "pointer",
  }}
>
  ← Return to Admin Dashboard
</button>
    </div>
  );
};

export default PurchaseOrders;
